const { MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { Button, Icon, Popover } = wp.components;
const { Fragment, useState, useRef } = wp.element;
import { __ } from '@wordpress/i18n';

const PgImageUploaderPopover = ({
  desktopImage,
  mobileImage,
  desktopImageKey,
  mobileImageKey,
  onUpdate,
}) => {
  const [showSettings, setShowSettings] = useState(false);
  const popoverRef = useRef();
  const desktopMediaLibraryRef = useRef();
  const mobileMediaLibraryRef = useRef();

  const handleImageSelect = (image, type) => {
    onUpdate({ [type]: image.url });
  };

  const handleImageRemove = (type) => {
    onUpdate({ [type]: '' });
  };

  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };

  return (
    <Fragment>
      <div className="pg-image-uploader">
        <Button
          isSmall
          onClick={toggleSettings}
          className="pg-image-settings"
          ref={popoverRef}
        >
          <Icon icon="format-image" />
        </Button>

        {showSettings && (
          <Popover
            anchor={popoverRef.current}
            onClose={() => setShowSettings(false)}
            position="bottom center"
          >
            <div className="pg-image-settings-popover">
              <h4>{__('Image Settings', 'pg')}</h4>

              <div>
                <h5>{__('Desktop Image', 'pg')}</h5>
                <Button
                  onClick={() => {
                    setShowSettings(false);
                    desktopMediaLibraryRef.current();
                  }}
                  isSecondary
                >
                  <Icon icon="format-image" />
                  {desktopImage
                    ? __('Change Image', 'pg')
                    : __('Upload Image', 'pg')}
                </Button>
                {desktopImage && (
                  <div>
                    <img src={desktopImage} alt={__('Desktop Image', 'pg')} />
                    <Button
                      isDestructive
                      onClick={() => handleImageRemove(desktopImageKey)}
                    >
                      <Icon icon="trash" /> {__('Remove Image')}
                    </Button>
                  </div>
                )}
              </div>

              {/* Mobile Image Upload */}
              <div>
                <h5>{__('Mobile Image', 'pg')}</h5>
                <Button
                  onClick={() => {
                    setShowSettings(false);
                    mobileMediaLibraryRef.current();
                  }}
                  isSecondary
                >
                  <Icon icon="format-image" />
                  {mobileImage
                    ? __('Change Image', 'pg')
                    : __('Upload Image', 'pg')}
                </Button>
                {mobileImage && (
                  <div>
                    <img src={mobileImage} alt={__('Mobile Image', 'pg')} />
                    <Button
                      isDestructive
                      onClick={() => handleImageRemove(mobileImageKey)}
                    >
                      <Icon icon="trash" /> {__('Remove Image')}
                    </Button>
                  </div>
                )}
              </div>

              {/* Close Settings */}
              <Button
                isPrimary
                onClick={() => setShowSettings(false)}
                className="pg-image-close-settings"
              >
                <Icon icon="no-alt" />
              </Button>
            </div>
          </Popover>
        )}

        {/* Media Upload Component for Desktop Image */}
        <MediaUploadCheck>
          <MediaUpload
            onSelect={(image) => handleImageSelect(image, desktopImageKey)}
            allowedTypes={['image']}
            render={({ open }) => {
              desktopMediaLibraryRef.current = open;
              return null; // Render nothing, just capture the open function
            }}
          />
        </MediaUploadCheck>

        {/* Media Upload Component for Mobile Image */}
        <MediaUploadCheck>
          <MediaUpload
            onSelect={(image) => handleImageSelect(image, mobileImageKey)}
            allowedTypes={['image']}
            render={({ open }) => {
              mobileMediaLibraryRef.current = open;
              return null; // Render nothing, just capture the open function
            }}
          />
        </MediaUploadCheck>
      </div>
    </Fragment>
  );
};

export default PgImageUploaderPopover;
